import { FeedbackForm, CONTACT_SUPPORT, SUPPORT_REQUEST_ID } from 'domain/shared/oneStop';
import { useState } from 'react';
import { useShowContext } from 'framework/show';
import { Button, LoaderSize, Loading } from 'framework/ui/mui-builder';
import Box from '@mui/material/Box';

const SupportRequestWithComplianceDocument = () => {
  const { data } = useShowContext();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);

  const {
    metadata: { complianceName, policyType, version },
  } = data.getData();
  const documentName = complianceName || policyType || '';

  const openFeedbackForm = () => setIsFormOpen(true);

  const closeFeedbackForm = () => setIsFormOpen(false);

  const loader = (
    <Box
      role="status"
      aria-hidden="true"
      sx={{
        position: 'relative',
        width: { xs: '1em', md: '17px' },
        height: { xs: '1em', md: '17px' },
        marginRight: { md: '11px' },
      }}
    >
      <Loading size={LoaderSize.Small} />
    </Box>
  );

  return (
    <>
      <Button link onClick={openFeedbackForm} sx={{ display: { xs: 'none', md: 'inline-flex' } }}>
        click here to get help.
        {isLoaderVisible ? loader : null}
      </Button>

      {isFormOpen && (
        <FeedbackForm
          formId={SUPPORT_REQUEST_ID}
          formTitle={CONTACT_SUPPORT}
          setIsLoaderVisible={setIsLoaderVisible}
          closeFeedbackForm={closeFeedbackForm}
          defaultValues={{
            subject: `Request to discuss ${documentName}, v.${version} before signing`,
            cf_84: "I'm not sure about the type of request",
          }}
        />
      )}
    </>
  );
};

export default SupportRequestWithComplianceDocument;
